import React from 'react'
// import MasterCard from '../PaymentGateways/MasterCard'

import CCAvenueStudyMaterial from '../PaymentGateways/CCAvenueStudyMaterial'
import StudyMaterialMasterCard from '../PaymentGateways/MasterCardStudyMaterial'

const StudyMaterial = ({ feeDetail, userDetail }) => {
    const {is_study_material_payment} = userDetail || {}
    const { payment_gateway } = feeDetail !== undefined && feeDetail
    // console.log('payment_gateway...', payment_gateway)
    return (
        <div className="row">
            <div className="col-lg-8 mx-auto text-center">
                <h4 className='mt-5 mb-2'>Study Materials</h4>
                <p className="mb-4">
                    Get access to comprehensive study materials designed to help you excel in your academics.
                    These resources cover all essential topics and are tailored to meet your learning needs.
                </p>
                <h5 className='mb-3'>Price: 500 (AED)</h5>
                <div className="row">
                    <div className="col-md-5 mx-auto">
                        {is_study_material_payment ===0 ? (
                                <div className="payment-gateways-list">
                                {payment_gateway?.length > 0 ?
    
                                    payment_gateway?.map((item) => (
                                        <React.Fragment key={item.id}>
                                            {(item.name ==='Master card' || item.name ==='Master Card') &&
                                            <StudyMaterialMasterCard 
                                            key={item.id}
                                            paymentConfig={item}  />}
    
                                            {item.name === 'CCavenue' && feeDetail !== undefined && feeDetail !== null &&
                                                <CCAvenueStudyMaterial
                                                    paymentConfig={item}
                                                    userDetail={userDetail !== undefined && userDetail}
                                                    feeDetail={feeDetail !== undefined && feeDetail}
                                                />
                                            }
                                        </React.Fragment>
                                    )
                                    )
    
                                    : <h5 className='text-center'>No Payment Gateway Found</h5>
                                }
                            </div>
                        ):<h4 class="text-secondary">Payment already paid</h4>}
                        
                    </div>
                </div>

            </div>
        </div>
    )
}

export default StudyMaterial  